<template>
    <el-form ref="formRef" :disabled="saving" :rules="rules" :model="{ travels }" label-position="top">
        <div v-for="(travel, i) in travels" :key="i" style="margin-bottom: 24px; border: 1px solid #ccc; padding: 16px; border-radius: 8px;">
            <el-form-item :prop="`travels.${i}.route_id`" label="Rota de viagem">
                <ElSelectV2 :clearable="false" filterable :loading="saving" name="route_id[]" v-model="travel.route_id" :options="routes" />
            </el-form-item>

            <el-form-item :prop="`travels.${i}.car_id`" label="Carro">
                <ElSelectV2 :clearable="false" filterable :loading="saving" name="car_id[]" v-model="travel.car_id" :options="cars" />
            </el-form-item>

            <el-form-item :prop="`travels.${i}.departure`" label="Hora de partida da Beira">
                <ElDatePicker type="datetime" format="DD/MM/YYYY HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" name="departure[]" :clearable="false" v-model="travel.departure" />
            </el-form-item>

            <el-button type="danger" @click="removeTravel(i)" v-if="travels.length > 1">Remover</el-button>
        </div>

        <!-- Botao de adicionar mais viagens -->
        <el-button :loading="saving" type="success" icon="Plus" @click.prevent="addTravel"></el-button>
        <el-button plain :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
            Marcar viagens
        </el-button>
    </el-form>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Car, Route, Travel } from "@/services/types";
import { toFormData } from "@/utilities/helpers";
    import { ElMessage, FormInstance, FormRules, ElSelectV2, ElDatePicker } from "element-plus"
    import { OptionType } from "element-plus/es/components/select-v2/src/select.types";
    import { reactive, ref, defineProps, defineEmits, computed } from "vue"

    const props = defineProps<{
        routes: Array<Route>,
        cars: Array<Car>
    }>()
    const emit = defineEmits<{close: []}>()

    const routes = computed<Array<OptionType>>(() => {
        return props.routes.map((value: Route) => {
            return {value: value.id, label: `${value.name}`}
        })
    })

    const cars = computed<Array<OptionType>>(() => {
        return props.cars.map((value: Car) => {
            return {value: value.id, label: `${value.name} [${value.plate}]`}
        })
    })

    const travels = ref<Array<Travel>>([{
        car_id: 0,
        departure: new Date(),
        route_id: 0,
    }])

    const rules = reactive<FormRules>({
        'travels': [{ required: true, type: 'array', message: 'Adicione pelo menos uma viagem', trigger: 'change' }],
        'travels.*.car_id': [{ required: true, message: 'Escolha um carro', trigger: 'change' }],
        'travels.*.departure': [{ required: true, message: 'Escolha a hora de partida', trigger: 'change' }],
        'travels.*.route_id': [{ required: true, message: 'Escolha uma rota', trigger: 'change' }],
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const addTravel = () => {
        travels.value.push({
            car_id: 0,
            departure: new Date(),
            route_id: 0,
        });
    };

    const removeTravel = (index: number) => {
        travels.value.splice(index, 1);
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const fd = toFormData({travels: travels.value})
                const res = await Api.post(`admin/travel`, {travels: travels.value}, fd)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Carro cadastrado com sucesso'})
                    emit('close')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
